module.exports = __webpack_public_path__ + "static/img/lb5.6d41840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb5.png
// module id = JT6D
// module chunks = 0